import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
const adres = "https://api.pth-hokej.pl";
const FormWrapper = styled.div`
  max-width: 900px;
  margin: 30px auto;
  padding: 40px;
  background-color: #fafafa;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  border: 1px solid #ddd;
`;

const Title = styled.h2`
  text-align: center;
  color: #5e0078;
  font-weight: 300;
  margin-bottom: 30px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  height: 150px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  margin-bottom: 20px;
`;

const Button = styled.button`
  width: 100%;
  padding: 14px;
  font-size: 16px;
  color: #5e0078;
  background-color: #c7fffb;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    box-shadow: -4px -4px 6px #eee;
  }
`;

const NewsList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 40px;
`;

const NewsItem = styled.li`
  padding: 10px;
  border-bottom: 1px solid #ccc;
`;

const ActionButton = styled.button`
  margin-right: 10px;
  padding: 6px 12px;
  background-color: #eee;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #ddd;
  }
`;

export const AddNewsForm = () => {
  const [formData, setFormData] = useState({
    data: new Date().toISOString().split("T")[0], // "2025-08-24"
    tytul: '',
    tresc: '',
    zdjecie: '',
  });



  const [zdjeciePlik, setZdjeciePlik] = useState(null);
  const [aktualnosci, setAktualnosci] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const fetchAktualnosci = async () => {
    try {
      const res = await fetch(`${adres}/api/aktualnosci`);
      const data = await res.json();
      setAktualnosci(data);
    } catch (err) {
      console.error('Błąd przy pobieraniu aktualności:', err);
    }
  };

  useEffect(() => {
    fetchAktualnosci();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = e => {
    setZdjeciePlik(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const method = editingId ? 'PUT' : 'POST';
    const url = editingId ? `${adres}/api/aktualnosci/${editingId}` : `${adres}/api/aktualnosci`;

    try {
      const fd = new FormData();
      fd.append('data', formData.data);
      fd.append('tytul', formData.tytul);
      fd.append('tresc', formData.tresc);

      // Jeśli wybrano plik – dodaj go
      if (zdjeciePlik) {
        fd.append('zdjeciePlik', zdjeciePlik);
      } else if (formData.zdjecie) {
        // Jeśli nie ma pliku, ale jest URL
        fd.append('zdjecie', formData.zdjecie);
      }

      const response = await fetch(url, {
        method,
        body: fd,
      });

      const result = await response.json();

      if (response.ok) {
        alert(editingId ? 'Aktualność zaktualizowana.' : 'Aktualność została dodana.');
        setFormData({ data: new Date().toISOString().split("T")[0], tytul: '', tresc: '', zdjecie: '' });
        setZdjeciePlik(null);
        setEditingId(null);
        fetchAktualnosci();
      } else {
        alert('Błąd: ' + (result.error || 'Nie udało się zapisać.'));
      }
    } catch (err) {
      console.error('Błąd przy wysyłaniu formularza:', err);
      alert('Wystąpił błąd podczas dodawania lub edytowania aktualności.');
    }
  };

  const handleDelete = async id => {
    if (!window.confirm('Czy na pewno chcesz usunąć tę aktualność?')) return;

    try {
      const res = await fetch(`${adres}/api/aktualnosci/${id}`, {
        method: 'DELETE',
      });

      if (res.ok) {
        alert('Aktualność została usunięta.');
        fetchAktualnosci();
      } else {
        alert('Błąd przy usuwaniu aktualności.');
      }
    } catch (err) {
      console.error('Błąd przy usuwaniu:', err);
      alert('Wystąpił błąd podczas usuwania aktualności.');
    }
  };

  const handleEdit = aktualnosc => {
    setFormData({
      data: aktualnosc.data,
      tytul: aktualnosc.tytul,
      tresc: aktualnosc.tresc,
      zdjecie: aktualnosc.zdjecie,
    });
    setZdjeciePlik(null);
    setEditingId(aktualnosc._id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <FormWrapper>
      <form onSubmit={handleSubmit}>
        <Title>{editingId ? 'Edytuj aktualność' : 'Dodaj nową aktualność'}</Title>

        <Label>Data</Label>
        <Input type="date" name="data" value={formData.data} onChange={handleChange} required />

        <Label>Tytuł</Label>
        <Input type="text" name="tytul" value={formData.tytul} onChange={handleChange} required />

        <Label>Treść</Label>
        <TextArea name="tresc" value={formData.tresc} onChange={handleChange} required />

        <Label>Link do zdjęcia (opcjonalnie)</Label>
        <Input type="url" name="zdjecie" value={formData.zdjecie} onChange={handleChange} />

        <Label>Lub dodaj zdjęcie z dysku</Label>
        <Input type="file" accept="image/*" onChange={handleFileChange} />

        <Button type="submit">{editingId ? 'Zapisz zmiany' : 'Zapisz aktualność'}</Button>
      </form>

      <NewsList>
        {aktualnosci.map(akt => (
          <NewsItem key={akt._id}>
            <strong>{akt.tytul}</strong> ({akt.data})
            <div>
              <ActionButton onClick={() => handleEdit(akt)}>Edytuj</ActionButton>
              <ActionButton onClick={() => handleDelete(akt._id)}>Usuń</ActionButton>
            </div>
          </NewsItem>
        ))}
      </NewsList>
    </FormWrapper>
  );
};
